import React from 'react'
import { connect } from 'react-redux'
import { fetchExpenses, editExpense, sortExpenses, filterExpenses, searchExpenses } from "../../actions/expenseActions"
import { addSets, fetchSets } from "../../actions/settings"
import ExpenseListItem from "./ExpenseListItem"
import ExpenseListPmnt from "./ExpenseListPmnt"
import ExpenseAddPostForm from "./ExpenseAddPostForm"
import isEmpty from 'lodash/isEmpty'
import Select from 'react-select'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import { fnum, sortOpts } from '../../utils/utils'

class ExpenseList extends React.Component {

  state = {
    adding: false
  }

  componentWillMount = () => {
    this.props.fetchExpenses();
    this.props.fetchSets('srvc');
  }

  startAdding = () => {
    this.setState({adding: true});
  }

  cancelAdding = () => {
    this.setState({
      adding: false
    });
  }

  handleFilter = (e, field) => {
    var arr = [];
    if(e){
      arr = e.split(',');
      arr = arr.map(el => {
        return parseInt(el, 10);
      });
    }
    this.props.filterExpenses({
      ...this.props.expenses.filter,
      [field]: arr
    });
  }

  handleFilterDate = (e, field) => {
    this.props.filterExpenses({
      ...this.props.expenses.filter,
      [field]: e.format('Y-MM-DD')
    });
  }

  handleSearch = (e, clear) => {
    if(clear){
      this.props.searchExpenses('');
    }
    else{
      const searchQuery = e.target.value.toLowerCase();
      this.props.searchExpenses(searchQuery);
    }
  }

  changeSort(asc){
    return (asc === 0) ? 1 : 0;
  }

  handleSort = (sortField) => {
    const currField = this.props.expenses.sort.field;
    const currAsc = this.props.expenses.sort.asc;
    const asc = sortField === currField ? this.changeSort(currAsc) : 1;
    this.props.sortExpenses({field:sortField,asc:asc});
  }

  render(){
    if(isEmpty(this.props.expenses.data)
      || isEmpty(this.props.srvgs)
      || isEmpty(this.props.srvcs)
      || isEmpty(this.props.comps)
    ){
      return(<div>Не загружены данные</div>);
    }
    const {
      expenses: { search, sort, filter, data: expenses },
      srvgs,
      srvcs,
      comps,
      ctypes,
      comprights,
      addSets,
      editExpense,
      settings
    } = this.props;
    const { adding } = this.state;

    const pmnts = {};
    const fltrExpenses = expenses.filter(el =>{
      if (el.post_active !== 1) {
        return false;
      }
      if (srvcs[el.post_srvc_id].srvc_type === -1) {
        if (pmnts[el.post_link]) {
          pmnts[el.post_link].push(el);
        }
        else {
          pmnts[el.post_link] = [el];
        }
        return false;
      }
      if(search !== ''){
        const searchValue = "" + el.post_desc + " " + el.post_note + " " +
          srvcs[el.post_srvc_id].srvc_desc;
        if (searchValue.toLowerCase().indexOf(search) === -1) {
          return false;
        }
      }
      if(!isEmpty(filter.comp)){
        if (filter.comp.indexOf(el.post_seller) === -1) {
          return false;
        }
      }
      if(!isEmpty(filter.srvg)){
        if (filter.srvg.indexOf(srvcs[el.post_srvc_id].srvc_srvg_id) === -1) {
          return false;
        }
      }
      if (el.post_bdate < filter.from || el.post_bdate > filter.to) {
        return false;
      }
      return true;
    });

    const srtExpenses = fltrExpenses.sort( (a, b) => {
      if(sort.field === 'comp_desc' && comps.hasOwnProperty(a.post_seller)
        && comps.hasOwnProperty(b.post_seller)){
        if(comps[a.post_seller].comp_desc < comps[b.post_seller].comp_desc)
          return sort.asc ? -1 : 1
        if(comps[a.post_seller].comp_desc > comps[b.post_seller].comp_desc)
          return sort.asc ? 1 : -1
      }
      if(sort.field === 'srvg_desc' && srvcs.hasOwnProperty(a.post_srvc_id)
        && srvcs.hasOwnProperty(b.post_srvc_id)){
        if(srvcs[a.post_srvc_id].srvc_srvg_id < srvcs[b.post_srvc_id].srvc_srvg_id)
          return sort.asc ? -1 : 1
        if(srvcs[a.post_srvc_id].srvc_srvg_id > srvcs[b.post_srvc_id].srvc_srvg_id)
          return sort.asc ? 1 : -1
      }
      if(sort.field === 'post_price'){
        if((a.post_price*a.post_qntt) < (b.post_price*b.post_qntt))
          return sort.asc ? -1 : 1
        if((a.post_price*a.post_qntt) > (b.post_price*b.post_qntt))
          return sort.asc ? 1 : -1
      }
      if(sort.field === 'post_desc'){
        if((""+srvcs[a.post_srvc_id].srvc_desc+a.post_desc) < (""+srvcs[b.post_srvc_id].srvc_desc+b.post_desc))
          return sort.asc ? -1 : 1
        if((""+srvcs[a.post_srvc_id].srvc_desc+a.post_desc) > (""+srvcs[b.post_srvc_id].srvc_desc+b.post_desc))
          return sort.asc ? 1 : -1
      }
      if(a[sort.field] < b[sort.field])
         return sort.asc ? -1 : 1
      if(a[sort.field] > b[sort.field])
         return sort.asc ? 1 : -1
      if(a.post_id < b.post_id)
         return sort.asc ? -1 : 1
      if(a.post_id > b.post_id)
         return sort.asc ? 1 : -1
      return 0
    });

    const mappedExpenses = [];

    for (let i = 0; i < srtExpenses.length; i++) {
      const expense = srtExpenses[i];
      mappedExpenses.push(
        <ExpenseListItem key={expense.post_id}
          data={expense}
          editExpense={editExpense}
          srvcs={srvcs}
          srvgs={srvgs}
          comps={comps}
          comprights={comprights}
          settings={settings}
          pmnts={pmnts[expense.post_id] || []}
        />
      );
      if (pmnts[expense.post_id]) {
        for (let j = 0; j < pmnts[expense.post_id].length; j++) {
          const pmnt = pmnts[expense.post_id][j];
          mappedExpenses.push(
            <ExpenseListPmnt key={pmnt.post_id}
              data={pmnt}
              editExpense={editExpense}
              srvcs={srvcs}
              srvgs={srvgs}
            />
          );
        }
      }
    }

    const expSum = srtExpenses.reduce((a, b) => {
      return a + b.post_price * b.post_qntt;
    }, 0);

    var srvgsOpt = [];
    for (var key in srvgs){
      if(srvgs.hasOwnProperty(key) && srvgs[key].srvg_active === 1) {
        srvgsOpt.push({value:srvgs[key].srvg_id,label:srvgs[key].srvg_desc});
      }
    }
    srvgsOpt.sort(sortOpts);

    var compsOpt = [];
    for (key in comps){
      if(comps.hasOwnProperty(key) && comps[key].comp_active) {
        if(comps[key].comp_expense){
          compsOpt.push({value:comps[key].comp_id,label:comps[key].comp_desc});
        }
      }
    }
    compsOpt.sort(sortOpts);

    const addNew = adding ?
      <ExpenseAddPostForm
        data={{
          post_desc: "",
          post_srvc_id: 0,
          post_order_id: 0,
          post_price: 0,
          post_qntt: 1,
          post_note: "",
          post_active: 1,
          post_seller: 0,
          post_payer: settings.default_order_comp_id || 0,
          post_bdate: moment().format('Y-MM-DD'),
          post_avans: 1,
          post_link: 0,
          pmnt_add: 1,
          pmnt_srvc_id: settings.default_expense_pmnt_srvc_id || 0,
          pmnt_bdate: moment().format('Y-MM-DD'),
          pmnt_payed: 1
        }}
        editExpense={editExpense}
        cancelAdding={this.cancelAdding}
        srvcs={srvcs}
        srvgs={srvgs}
        comps={comps}
        ctypes={ctypes}
        comprights={comprights}
        addSets={addSets}
        srvcType={filter.type}
      />
      : [];

    return (
      <div>
        {addNew}
        <div className="form-group form-inline">
          <button className="btn btn-primary" onClick={this.startAdding}>Создать</button>
          {" "}
          <div className="input-group">
            <input
              type="search"
              className="form-control"
              value={search}
              title="Поиск"
              placeholder="Поиск"
              onChange={this.handleSearch} />
            <div className="input-group-btn">
              <button
                type="button"
                className="btn btn-default"
                onClick={(e) => this.handleSearch(e, true)}
                title="Очистить поиск">
                X
              </button>
            </div>
          </div>{" "}
          <div className="input-group">{srtExpenses.length} позиций на сумму {fnum(expSum)}</div>
        </div>
        <div className="form-group form-inline">
          <div className="input-group">
            <Select
              style={{width:'230px'}}
              options={srvgsOpt}
              multi={true}
              simpleValue={true}
              value={filter.srvg}
              onChange={(e) => this.handleFilter(e, 'srvg')}
              placeholder="Группа услуг"
            />
          </div>{" "}
          <div className="input-group">
            <Select
              style={{width:'230px'}}
              options={compsOpt}
              multi={true}
              simpleValue={true}
              value={filter.comp}
              onChange={(e) => this.handleFilter(e, 'comp')}
              placeholder="Поставщик"
            />
          </div>{" "}
          <div style={{display:'inline-block'}}>
            <DatePicker
              className="form-control"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              selected={moment(filter.from)}
              selectsStart
              startDate={moment(filter.from)}
              endDate={moment(filter.to)}
              onChange={(e) => this.handleFilterDate(e, 'from')}
            />
          </div>{" - "}
          <div style={{display:'inline-block'}}>
            <DatePicker
              className="form-control"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              selected={moment(filter.to)}
              selectsStart
              startDate={moment(filter.from)}
              endDate={moment(filter.to)}
              onChange={(e) => this.handleFilterDate(e, 'to')}
            />
          </div>
        </div>
        <table className="table table-hover">
          <thead>
            <tr style={{cursor:'pointer'}}>
              <th className="col-sm-3" onClick={() => {this.handleSort('post_desc')}}>Услуга, описание</th>
              <th className="col-sm-1 text-right" onClick={() => {this.handleSort('post_price')}}>Сумма</th>
              <th className="col-sm-1" onClick={() => {this.handleSort('post_bdate')}}>Дата</th>
              <th className="col-sm-2" onClick={() => {this.handleSort('comp_desc')}}>Поставщик</th>
              <th className="col-sm-2" onClick={() => {this.handleSort('srvg_desc')}}>Группа услуг</th>
              <th className="col-sm-3" onClick={() => {this.handleSort('post_note')}}>Заметка</th>
            </tr>
          </thead>
          <tbody>
            {mappedExpenses}
          </tbody>
        </table>
      </div>
    )

  }
}

function mapOrdersToProps(store) {
  return {
    expenses: store.expenses,
    comps: store.comps.data,
    srvcs: store.srvcs.data,
    srvgs: store.srvgs.data,
    ctypes: store.ctypes.data,
    comprights: store.auth.comprights,
    settings: store.settings
  }
}

export default connect(mapOrdersToProps, {
  fetchExpenses,
  editExpense,
  sortExpenses,
  filterExpenses,
  searchExpenses,
  addSets,
  fetchSets
})(ExpenseList);



// WEBPACK FOOTER //
// ./src/components/expense/ExpenseList.js